import React from 'react'
import './style.sass'
type Props = {
	title: string
}
export default function OffScreenHeader({ title }: Props): React.ReactNode {
	return <h1 className='OffScreen__Header'>{title}</h1>
}
